import { MuiThemeProvider } from '@material-ui/core';
import LeftMenu from 'components/LeftMenu';
import Loading from 'components/Loading';
import { ITopBarMenuItem } from 'components/TopBar/TopBarMenuItem';
import React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, Switch, withRouter } from 'react-router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { IAuthReducer } from 'store/modules/AuthReducer';
import { IReducer } from 'store/Reducer';
import ModalsManager from '../ModalsManager/ModalsManager';
import TopBar from '../TopBar/TopBar';
import { getAllRouteComponents } from './../../library/Routes';
import LayoutContext from './LayoutContext';
import { LayoutMuiTheme } from './LayoutMuiTheme';

export interface ILayout extends RouteComponentProps<any> {
  auth?: IAuthReducer,
}

export interface ILayoutState {
  isMobile: boolean;
  manualRefreshInterval?: NodeJS.Timeout | number | undefined;
  pageMenuItems: ITopBarMenuItem[];
  toolbarReadOnly?: boolean;
  isLoading?: boolean;
  loadingMessage?: string;
  disableNavDrawer?: boolean;
}

export const isMobileMediaQuery: string = '(max-width: 768px)';

class Layout extends React.Component<ILayout, ILayoutState> {

  constructor(props: any) {
    super(props);
    this.state = {
      isMobile: window.matchMedia(isMobileMediaQuery).matches,
      pageMenuItems: [],
      toolbarReadOnly: false,
      isLoading: false,
    };
  }

  onMediaQuery = (event: MediaQueryListEvent) => {
    this.setState({
      isMobile: event.matches
    });
  }

  componentDidMount() {
    window.matchMedia(isMobileMediaQuery).addListener(this.onMediaQuery);
  }

  UNSAFE_componentWillUnmount() {
    window.matchMedia(isMobileMediaQuery).removeListener(this.onMediaQuery);
  }

  setPageMenuItems = (menuItems?: ITopBarMenuItem[]) => {
    this.setState({
      pageMenuItems: menuItems || [],
    });
  };

  setToolbarReadOnly = (readOnly: boolean) => {
    this.setState({
      toolbarReadOnly: readOnly,
    });
  };

  startLoading = (message?: string, flg?: boolean) => {
    this.setState({
      isLoading: flg,
      loadingMessage: message,
    });
  };

  finishLoading = () => {
    this.setState({
      isLoading: false,
      loadingMessage: undefined,
    });
  };

  setDisableNavDrawer = (value: boolean) => {
    this.setState({
      disableNavDrawer: value,
    });
  };

  render() {
    const { isMobile, isLoading, loadingMessage, disableNavDrawer } = this.state;
    const { auth } = this.props;
    const isLogged = auth!.logged;
    return (
      <LayoutContext.Provider
        value={{
          isMobile,
          isLogged,
          setPageMenuItems: this.setPageMenuItems,
          pageMenuItems: this.state.pageMenuItems,
          setToolbarReadOnly: this.setToolbarReadOnly,
          headerHeight: this.state.pageMenuItems && this.state.pageMenuItems.length > 0 ? 84 : 52,
          startLoading: this.startLoading,
          finishLoading: this.finishLoading,
          setDisableNavDrawer: this.setDisableNavDrawer,
          disableNavDrawer,
        }}
      >
        <MuiThemeProvider theme={ LayoutMuiTheme }>
          {isLogged ? (
            <TopBar
              readOnly={this.state.toolbarReadOnly}
              mostrarSaudacao={!isMobile}
              disableLeftMenu={disableNavDrawer}
            />
          ) : null}
          <div>
            <Switch>
              { getAllRouteComponents() }
            </Switch>
          </div>
          {
            isLogged ? <LeftMenu /> : null
          }
          <ModalsManager />
          {isLoading && <Loading text={loadingMessage} />}
          <ToastContainer />
        </MuiThemeProvider>
      </LayoutContext.Provider>
    );
  }
}

const mapStateToProps = (state:IReducer) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps)(withRouter(Layout));